<template>
    <div class="recommend-title">
        <span :class="'one ' +(icon ||' one-notebook')"/>
        <label class="title-container">
            <span class="title-text">{{title}}</span>
        </label>
        <span class="tip-content"> {{tip}}</span>
    </div>
</template>

<script>
    export default {
        name: "TitleInfo",
        props: {tip: String, title: String, icon: String}
    }
</script>

<style scoped lang="scss">
    .recommend-title {
        font-size: 16px;
        color: #ED6C00;
        font-weight: 600;
        text-align: left;

        .title-container {
            display: inline-block;
            width: 824px;
            padding-bottom: 8px;

            .title-text {
                font-weight: 600;
                font-size: 16px;
                color: #ED6C00;
                border-bottom: 2px solid #ED6C00;
                padding-bottom: 8px;
            }

            border-bottom: 1px solid #C4C4C4;
        }

        .tip-content {
            padding: 18px 18px 18px 30px;
            display: block;
            width: 576px;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            color: #6A6A6A;
        }

        .one {
            color: #ED6C00;
            font-size: 20px;
            position: relative;
            top: 4px;
            left: 4px;
            margin-right: 9px;
        }
    }

</style>